import axios from 'axios'
import { getAppHost, getAppEndpointVersion } from 'helpers'

// MCP SERVER METHODS
// Create MCP Server
export const createMcpServer = async (app, appSettings, mcpServerData) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/mcp-servers`

    const response = await axios.post(baseURL, mcpServerData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Update MCP Server
export const updateMcpServer = async (app, appSettings, mcpServerData) => {
  const { slug, ...restData } = mcpServerData // destructure and remove slug

  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/mcp-servers/${encodeURIComponent(slug)}`

    const response = await axios.patch(baseURL, restData, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Delete MCP Server
export const deleteMcpServer = async (app, appSettings, slug) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/mcp-servers/${encodeURIComponent(slug)}`

    const response = await axios.delete(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// List MCP Servers
export const listMcpServers = async (app, appSettings, paginationPayload = '') => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/mcp-servers`

    // Build URL with pagination payload (affix=append&createdAt=timestamp or affix=prepend&createdAt=timestamp)
    let url = baseURL
    if (paginationPayload) {
      url = `${baseURL}?limit=10&${paginationPayload}`
    } else {
      // Default first load
      url = `${baseURL}?limit=10`
    }

    const response = await axios.get(url, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Add MCP Server to Agent
export const addMcpServer = async (app, appSettings, agentId, mcpServers) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentId}/mcp/add`

    const response = await axios.patch(baseURL, mcpServers, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Remove MCP Server from Agent
export const removeMcpServer = async (app, appSettings, agentId, mcpServers) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentId}/mcp/remove`

    const response = await axios.patch(baseURL, mcpServers, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
